import { Latin } from '../../../core/languages/Latin';
import { SeparatedViewSeparator } from './converter.core';
import { IsClef } from './gabcExceptions';
import { split_string } from '../../utils/helpers';

const latin = new Latin();

export function syllabifyWord(word: string, trimParantness = true): string[] {
  if (!word.includes('(')) {
    return latin.syllabifyWord(word);
  }

  const result: string[] = [];

  let buf = '';
  let manualMode = false;
  for (let i = 0; i < word.length; i++) {
    const char = word[i];

    if (char === '(') {
      if (buf) {
        const syllables = latin.syllabifyWord(buf);
        result.push(...syllables);
        buf = '';
      }
      manualMode = true;
      if (!trimParantness) {
        buf += char;
      }
      continue;
    } else if (char === ')') {
      manualMode = false;
      if (!trimParantness) {
        buf += char;
      }
      result.push(buf);
      buf = '';
      continue;
    } else {
      buf += char;
    }
  }

  if (buf) {
    if (manualMode) {
      result.push(buf);
    } else {
      const syllables = latin.syllabifyWord(buf);
      result.push(...syllables);
    }
  }

  return result;
}

export function from_separated_to_compounded(
  lyrics: string,
  gabc: string,
  nabc?: string,
  metadata?: string,
): string {
  const wordsArr = split_string(lyrics, false);
  const lyricsArr = wordsArr.map((word) => syllabifyWord(word));

  const gabcArr = split_string(gabc, true);

  let nabcArr: string[] = [];
  if (nabc) {
    nabcArr = split_string(nabc, true);
  }

  let buffer = '';

  let gabcExceptionsCounter = 0;
  let notationsCursor = 0;

  for (let i = 0; i < lyricsArr.length; i++) {
    const lyricsWord = lyricsArr[i];

    if (i > 0) {
      buffer += ' ';
    }

    for (let j = 0; j < lyricsWord.length; j++) {
      const lyricsSyllable = lyricsWord[j];
      let gabcWord = gabcArr[notationsCursor + gabcExceptionsCounter];

      if (IsClef(gabcWord)) {
        buffer += '(' + gabcWord + ') ';
        gabcExceptionsCounter++;
        gabcWord = gabcArr[notationsCursor + gabcExceptionsCounter];
      }

      const nabcWord = nabcArr[notationsCursor];

      buffer += lyricsSyllable;

      if (gabcWord) {
        buffer += '(';

        const gabcSegmentArr = gabcWord.split(SeparatedViewSeparator);
        let nabcSegmentArr: string[] = [];
        if (nabcWord) {
          nabcSegmentArr = nabcWord.split(SeparatedViewSeparator);
        }

        for (let k = 0; k < gabcSegmentArr.length; k++) {
          if (k > 0) {
            buffer += '|';
          }
          const gabcSegment = gabcSegmentArr[k];
          const nabcSegment = nabcSegmentArr[k];

          buffer += gabcSegment;
          if (gabcSegment || nabcSegment) {
            buffer += '|';
          }
          if (nabcSegment) {
            buffer += nabcSegment;
          }
        }

        if (buffer.endsWith('|')) {
          buffer = buffer.slice(0, -1);
        }

        buffer += ')';
      } else if (nabcWord) {
        const nabcSegmentArr = nabcWord.split(SeparatedViewSeparator);
        buffer += '(|' + nabcSegmentArr.join('||') + ')';
      } else {
        buffer += '()';
      }

      notationsCursor++;
    }
  }

  while (notationsCursor + gabcExceptionsCounter < gabcArr.length) {
    buffer += ' ';
    buffer += '(' + gabcArr[notationsCursor + gabcExceptionsCounter] + ')';
    notationsCursor++;
  }

  if (metadata) {
    buffer = metadata + (metadata.endsWith('\n') ? '' : '\n') + '%%\n' + buffer;
  }

  return buffer;
}
